import validator from 'validator';

import { PAYMENT_METHODS, type PaymentMethodT } from './users';

export function isValidCity(city: string): boolean {
  return !!city;
}

export function isValidCountry(country: string): boolean {
  return !!country;
}

export function isValidEmail(email: string): boolean {
  return validator.isEmail(email);
}

export function isValidName(name: string): boolean {
  return !!name.trim();
}

export function isValidPaymentMethod(
  paymentMethod: null | string | undefined,
): paymentMethod is PaymentMethodT {
  return !!paymentMethod
    && PAYMENT_METHODS.includes(paymentMethod as PaymentMethodT);
}

export function isValidPhone(phone: string): boolean {
  return validator.isMobilePhone(phone);
}

export function isValidPhoneOrEmpty(phone: string): boolean {
  return !phone || validator.isMobilePhone(phone);
}

export function isValidUrl(url: string): boolean {
  return validator.isURL(url, {
    // eslint-disable-next-line camelcase
    require_protocol: true,
  });
}
